module.exports = __webpack_public_path__ + "img/rowbg.48718171.png";